module.exports = __webpack_public_path__ + "static/media/charts-pie-bg.dd9aee15.svg";